/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
// import { ReactComponent as LoginKeyIcon } from '../../assets/images/loginKey.svg';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ReactComponent as LoginMailIcon } from '../assets/images/loginMailIcon.svg';
import s10Logo from '../assets/images/s10Logo.png';

import { Button, Grid, InputAdornment, Typography, Divider, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MyTextField from './MyTextField';

import { useFormik } from 'formik';
import LoadingComponent from './LoadingComponent';
import MySnackbar from './MySnackbar';
import { loginRequest } from '../api/authApi';
import { getUserIsAdmin } from '../api/employeePortal';
import { useNavigate } from 'react-router-dom';
import { AuthData } from '../types';
// import { Link } from 'react-router-dom';


const ValidationSchema = Yup.object().shape({
  username: Yup.string()
    .email('El usuario ingresado es inválido.')
    .required('El usuario es requerido.'),
  password: Yup.string()
    .min(4, 'Contraseña muy corta')
    // .max(50, 'Too Long!')
    .required('La contraseña es requerida'),
});

interface Props {
  loginData: null | AuthData;
  setLoginData: (data: AuthData | null) => void
}

const Login = ({loginData, setLoginData}: Props) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!loginData?.UserId) {
      return;
    }
    navigate('/');
  }, [loginData])

  useEffect(() => {
    const savedUsername = localStorage.getItem("rememberedUsername");
    if (savedUsername) {
      formik.setFieldValue("username", savedUsername);
      formik.setFieldValue("rememberMe", true);
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const loginHandler = async () => {
    const { username, password, rememberMe } = formik.values;

    if (!username || !password) {
      setErrorMsg("Email y password son requeridos.");
      return;
    }
    if (rememberMe) {
      localStorage.setItem("rememberedUsername", username);
    } else {
      localStorage.removeItem("rememberedUsername");
    }
    setLoading(true);
    const result = await loginRequest({UserName: username, Password: password})
                          .finally(() => setLoading(false));
    console.log(result)
    if (result?.data?.Type === 0) {
      const loginData = result?.data?.Value;
      const userIsAdminResponse = await getUserIsAdmin(`${loginData.UserId}`);
      const userIsAdmin = userIsAdminResponse?.success ? userIsAdminResponse?.data : {};
      await localStorage.setItem("loginData", JSON.stringify({...loginData, userIsAdmin}));
      // setUpdateLoginData(new Date());
      setLoginData({...loginData, userIsAdmin})
      navigate('/');
      return;
    }
    setErrorMsg(result?.data?.Message || "Error al iniciar sesión.");
  };

  const formik = useFormik({
    initialValues: { 
      username: localStorage.getItem("rememberedUsername") || "", 
      password: "", 
      rememberMe: !!localStorage.getItem("rememberedUsername")
     },
    validationSchema: ValidationSchema,
    onSubmit: loginHandler,
  });

  // if (loading) {
  //   return <label>Cargando...</label>;
  // }

  return (
    <Grid container style={{ height: "100vh", margin: "0 !important" }}>
      <Grid
        container
        item
        xs={12}
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ backgroundColor: theme.s10palette.S10Blueblue50 }}
      >
        <MySnackbar
          open={!!errorMsg}
          autoHideDuration={6000}
          msg={errorMsg}
          severity="error"
          onClose={() => setErrorMsg('')}
        />
        <Grid
          container
          direction="row"
          maxWidth="20rem"
          alignItems="center"
          rowSpacing="1rem"
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Grid justifyContent="center" alignItems="center" alignContent="center" item xs={12} >
            <img style={{ width: "8.75rem" }} src={s10Logo} alt="S10" />
          </Grid>
          <Typography variant="h3" style={{ marginBottom: "0.5rem" }}>
            ¡Bienvenido!
          </Typography>
          <Typography variant="h6">Portal de ayuda para usuarios de S10 - Ingresar</Typography>
          <Divider
            style={{
              width: "100%",
              marginTop: "1.19rem",
              marginBottom: "1.5rem",
              color: theme.s10palette.S10Blueblue100,
            }}
          />
          <Typography variant="body1" align="left" width="100%">
            Ingresa tus credenciales
          </Typography>
          <MyTextField
            id="username"
            label="Usuario"
            type="text"
            name="username"
            value={formik.values.username}
            onChange={formik.handleChange}
            error={formik.values.username.length > 3 && Boolean(formik.errors.username)}
            helperText={formik.values.username.length > 3 ? formik.errors.username : ""}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ color: theme.s10palette.S10Greygrey900 }}>
                  <LoginMailIcon />
                </InputAdornment>
              ),
            }}
          />
          <Grid item >
            <MyTextField
              id="password"
              label="Contraseña"
              type={showPassword ? "text" : "password"}
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.values.password.length > 3 && Boolean(formik.errors.password)}
              helperText={formik.values.password.length > 3 ? formik.errors.password : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <FormControlLabel
            control={
              <Checkbox
                checked={formik.values.rememberMe}
                onChange={(e) => formik.setFieldValue("rememberMe", e.target.checked)}
                color="primary"
              />
            }
            label="Recordarme"
          />
          <Grid item width="20rem" style={{ marginTop: "1rem" }}>
            <Button variant="contained" type="submit" fullWidth>
              Iniciar sesión
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {loading && <LoadingComponent loadingText="Iniciando sesión..." />}
    </Grid>
  );
};

export default Login;
